import { render, staticRenderFns } from "./EVMMetadata.vue?vue&type=template&id=457d48af&scoped=true&"
import script from "./EVMMetadata.vue?vue&type=script&lang=ts&"
export * from "./EVMMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d48af",
  null
  
)

export default component.exports